/**
 * Investor Adapter
 * Authority: ADAPTER AGENT (Stability V2)
 */
import { getContractDefaults } from '../contracts/render_contracts';

/** Title Case: capitalize first letter of each word */
const toTitleCase = (str) =>
    str.replace(/\b\w/g, (c) => c.toUpperCase());

export const adaptInvestor = (raw) => {
    const d = getContractDefaults('Investor');
    if (!raw) return d;

    // Fund Name Derivation (Centralized)
    const fundName = toTitleCase(raw.fund_name || raw.name || d.display_name);

    return {
        ...d,
        id: raw.id || raw._id || "",
        display_name: fundName,
        subtitle: raw.type || d.subtitle,
        geo_label: raw.geo_focus || raw.geo || d.geo_label,
        sectors: Array.isArray(raw.sectors) ? raw.sectors : d.sectors,
        avatar_initial: fundName.charAt(0).toUpperCase() || d.avatar_initial
    };
};
